import { SharedModule } from '../shared/shared.module'
import { NgModule } from '@angular/core'
import { CollectionsBaseModule } from '../collections/collections-base.module'
import { LeaguesRoutingModule } from '../leagues/leagues-routing.module'
import { LeaguesListModule } from './leagues-list/leagues-list.module'

@NgModule({
  imports: [SharedModule, LeaguesListModule, LeaguesRoutingModule, CollectionsBaseModule],
  exports: []
})
export class LeaguesModule {}
